module.exports = __webpack_public_path__ + "img/NYCSkylinePano.45c12ed1.jpg";